import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentFailed() {
    const [params] = useSearchParams();
    const reason = params.get("reason") || "We couldn't complete your payment.";
    return (
        <div className="section" data-testid="payment-failed-page">
            <div className="container-atm">
                <div className="card-soft mx-auto max-w-2xl p-10 text-center">
                    <span className="mx-auto inline-flex rounded-full bg-rose-50 p-3 text-rose-600">
                        <XCircle size={32} />
                    </span>
                    <h1 className="mt-6 text-3xl font-semibold">Payment failed</h1>
                    <p className="mt-3 text-[15px] text-[#475569]" data-testid="payment-failed-reason">
                        {reason}
                    </p>
                    <p className="mt-2 text-sm text-[#0E2A47]/70">
                        Your booking is still saved as unpaid. You can retry with the same card or a different one.
                    </p>
                    <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <Link to="/book" className="btn-primary inline-flex" data-testid="failed-try-again">
                            Try again <ArrowRight size={16} />
                        </Link>
                        <Link to="/about" className="btn-secondary inline-flex">
                            Contact support
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
